import styled from 'styled-components';

import { Container } from 'components/Container';

export const Footer = styled(Container).attrs(() => ({
  background: 'black',
  columns: 5,
  gap: 8,
}))``;
